export * from '@devstroupe/components/fullscreen/public-api';
